<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useOrganizationStore } from "~/modules/organization/stores/useOrganizationStore";
import { useSectorStore } from "~/modules/sector/stores/useSectorStore";
import { useUserSession } from "~/modules/user/stores/useUserSession";

const { selectedSectorCodes } = storeToRefs(useSectorStore());
const { currentOrganization } = storeToRefs(useOrganizationStore());
const { userSession } = storeToRefs(useUserSession());

const userAssignedSectorsCodes = computed(() => {
  return userSession.value?.sectors.map((sector) => sector.code) || [];
});
</script>

<template>
  <page-component check-license>
    <div class="w-full grid grid-cols-2 gap-6">
      <dashboard-dtwin-life-cycle-state
        :organization-code="currentOrganization?.code"
        :selected-sectors-code="selectedSectorCodes"
        :user-assigned-sectors-codes="userAssignedSectorsCodes"
      />
      <dashboard-dtwin-certificate
        :organization-code="currentOrganization?.code"
        :selected-sector-codes="selectedSectorCodes"
        :user-assigned-sectors-codes="userAssignedSectorsCodes"
      />
      <dashboard-dtwin-connectivity
        :organization-code="currentOrganization?.code"
        :selected-sector-codes="selectedSectorCodes"
        :user-assigned-sectors-codes="userAssignedSectorsCodes"
      />
      <dashboard-dtwin-firmware-version
        :organization-code="currentOrganization?.code"
        :selected-sector-codes="selectedSectorCodes"
        :user-assigned-sectors-codes="userAssignedSectorsCodes"
      />
    </div>
  </page-component>
</template>
